import { useLocalStore, useObserver } from 'mobx-react-lite';
import VolleyballMatchBroadcastModel from './model';
import { runInAction, toJS } from 'mobx';
import WebSocketUtil from '../../../../common/utils/socketUtil';
import { ScoreDetailService } from '../../../../common/services';
import { ObjectUtil } from '../../../../common/utils/objectUtil';

const VolleyballBroadcastStore = () => {
  const store = useLocalStore(() => ({
    broadcast: {},
    awayComment: {
      list: [],
      percent: 0,
      total_cnt: 0
    },
    homeComment: {
      list: [],
      percent: 0,
      total_cnt: 0
    },
    page: { home: 1, away: 1 },
    loading: true,
    init: false,
    socket: null,
    isSub: false,
    gameId: null,
    selectedPeriod: null,
    isAuto: false,
    autoCount: 5,
    intervals: null,
    connectSocket(topic) {
      store.socket = new WebSocketUtil(topic);
      store.socket.ws.onmessage = (event) => {
        if (event) {
          let data = event.data;
          try {
            if (data === 'OK') {
              store.isSub = true;
            } else {
              let messageData = JSON.parse(data);
              if (messageData) {
                const { TOPIC, MESSAGE } = messageData;
                const data = JSON.parse(MESSAGE);
                if (!!store.gameId) {
                  if (
                    TOPIC === `sports.volleyball.broadcasts.${store.gameId}`
                  ) {
                    data.broadcasts
                      .sort((a, b) => {
                        if (a.period < b.period) return -1;
                        if (a.period > b.period) return 1;
                        if (a.viewGrouSequence < b.viewGrouSequence) return -1;
                        if (a.viewGrouSequence > b.viewGrouSequence) return 1;
                        else return 0;
                      })
                      .forEach((item) => {
                        if (store.broadcast.hasOwnProperty(item.period)) {
                          store.broadcast[item.period].updateBroadcast(item);
                        } else {
                          store.broadcast[
                            item.period
                          ] = new VolleyballMatchBroadcastModel([item]);
                          store.selectedPeriod = item.period;
                        }
                      });
                  }
                }
              }
            }
          } catch (error) {
            console.log('=== socket on message error ===', error);
          }
        }
      };
    },
    closeSocket() {
      store.socket.close(() => {
        runInAction(() => {
          store.isSub = false;
          store.socket = null;
        });
      });
    },
    async getBroadcast(gameId) {
      if (!store.isSub) {
        store.connectSocket([`sports.volleyball.broadcasts.${gameId}`]);
      }

      const result = await ScoreDetailService.getBroadcastsBySportsType(
        'volleyball',
        gameId
      );

      if (ObjectUtil.isNotNull(result)) {
        const deep = { ...result };
        const keys = Object.keys(result);

        keys.forEach((key) => {
          deep[key] = new VolleyballMatchBroadcastModel(deep[key]);
        });

        let progressPeriod = +keys.pop();

        store.selectedPeriod = progressPeriod;
        store.gameId = gameId;
        store.broadcast = deep;
      }
      store.loading = false;
    },
    get getPeriodBroadcast() {
      const { selectedPeriod, broadcast } = store;

      //  99는 전체
      let result = {};
      const keys = Object.keys(broadcast).reverse();

      keys.forEach((key) => {
        result = { ...result, [key]: [...broadcast[key].getList] };
      });

      if (ObjectUtil.isNotNull(result)) {
        return result;
      } else {
        return null;
      }
    },
    setSelectedPeriod(period) {
      store.selectedPeriod = period;
    },
    onChangePage(gameId, location, num) {
      runInAction(() => {
        if (location === 'home') {
          store.page = {
            ...store.page,
            home: num
          };
        } else {
          store.page = {
            ...store.page,
            away: num
          };
        }

        runInAction(() => {
          store.getSportsMatchComment(gameId);
        });
      });
    },
    commentRefresh() {
      runInAction(() => {
        store.page = { home: 1, away: 1 };

        runInAction(() => {
          store.getSportsMatchComment(store.gameId);
        });
      });
    },
    toggleAuto() {
      runInAction(() => {
        store.isAuto = !store.isAuto;

        if (store.isAuto) {
          runInAction(() => {
            store.intervals = setInterval(() => {
              if (store.autoCount > 1) {
                store.autoCount = store.autoCount - 1;
              } else if (store.autoCount === 1) {
                setTimeout(() => {
                  store.autoCount = 0;

                  runInAction(() => {
                    store.commentRefresh();
                    store.autoCount = 5;
                  });
                }, 1000);
              }
            }, 1000);
          });
        } else {
          store.autoCount = 5;
          clearInterval(store.intervals);

          runInAction(() => {
            store.intervals = null;
          });
        }
      });
    },
    updateGameStatus(gameStatus) {
      let progressPeriod = store.selectedPeriod;

      if (gameStatus === 'FINAL') {
        progressPeriod = 99;
      }

      store.selectedPeriod = progressPeriod;
    }
  }));

  return {
    getBroadcast: store.getBroadcast,
    onChangePage: store.onChangePage,
    commentRefresh: store.commentRefresh,
    toggleAuto: store.toggleAuto,
    closeSocket: store.closeSocket,
    updateGameStatus: store.updateGameStatus,
    data: useObserver(() => {
      return {
        init: store.init,
        loading: store.loading,
        broadcast: store.broadcast,
        getPeriodBroadcast: store.getPeriodBroadcast,
        setSelectedPeriod: store.setSelectedPeriod,
        selectedPeriod: store.selectedPeriod,
        homeComment: store.homeComment,
        awayComment: store.awayComment,
        page: store.page,
        isAuto: store.isAuto,
        autoCount: store.autoCount
      };
    })
  };
};

export default VolleyballBroadcastStore;
